"use client";
import { useEffect, useContext } from "react";
import { useDataLayerContext } from "./DataLayerContextProvider";
import { SessionContext } from "@/lib/auth/SessionContextProvider";
import { BigCommerceStoreContext } from "@/providers/BigCommerceStoreProvider";
import { ProductData } from "@/lib/5874/types";

interface Props {
	datalayerProducts: ProductData[] | undefined;
	searchTerm: string;
}

export default function SearchViewEvent({
	datalayerProducts,
	searchTerm,
}: Props) {
	const { viewSearchResults } = useDataLayerContext();
	const session = useContext(SessionContext);
	const { currencyFormattingRules } = useContext(BigCommerceStoreContext);
	const isLoggedIn = session?.session !== undefined;
	const scope = "search_results_page";

	useEffect(() => {
		viewSearchResults(
			datalayerProducts ?? [],
			searchTerm,
			scope,
			currencyFormattingRules.currency,
			isLoggedIn,
			scope,
			scope,
		);
	}, [searchTerm]);

	return null;
}
